import _ from "underscore";
import {RadioGroup} from '../groups/radioGroup'
import {CellItem} from './cellItem'
import {ValidateResult} from '../contentType'
import {XmlTagInfo} from "../xmlTagProvider";
import {radioItemView} from "../../ui/items/radio";
import {Vnode} from "mithril";
import {areStringInNaturalOrder} from "../utils";

export class RadioItem extends CellItem {

	private value: any;
	private keyboardShortcut: string;
	private visible: boolean;

	static fromXml(config: XmlTagInfo){
		return new RadioItem(config);
	}

	constructor(config: XmlTagInfo){
		super(config);
		this.value = config.attributes['value']; // TODO add parseInt()
		this.keyboardShortcut = config.attributes['keyboardShortcut'] + '';
		this.visible = config.attributes['visible'] !== 'no';  // Default is yes
	}

	getView():Vnode {
	    // @ts-ignore
		return radioItemView(this);
	}

	isChecked(){
		/* tslint:disable:triple-equals */
		return this.getVariable() == this.value; // only "==" because of null or undefined or 0
		/* tslint:enable */
	}

	active(){
		return this.isChecked()
	}

	/** Used by cumulative radios */
	showAsActive () {
        if ((<RadioGroup>this.group).cumulative) {
            return areStringInNaturalOrder(this.value, this.getVariable()) || areStringInNaturalOrder(this.value, (<RadioGroup>this.group).virtualValue);
        }

        return this.isChecked();
	}

	set(){
		if(this.cell.enabled){
			this.setVariable(this.value);
            this.updateUnknowns();
			this.form.reValidate();
		}
	}

	unset() {
		if( this.active() ) {
			this.setVariable(null);
		}
	}

	validate (){
		// TODO by group
		const variable = this.getVariable();
		return new ValidateResult(! _.isUndefined(variable) && variable !== null, []);
	}

	globalKeyPressed(e: KeyboardEvent){
		const pressed = e.key; // catch shift, alt, ctrl... but it is ok
		if(pressed && this.keyboardShortcut.toLowerCase() === pressed.toLowerCase()){
			this.set();
		}
	}

	reset() {
		if(this.isChecked()){
			this.setVariable(null);
		}
	}

	empty() {
		return this.getVariable() == null;
	}

	resourcesToPreload(){
		return this.getSimpleContentResources(this.childrenTags);
	}

	isVisible(): boolean {
		return this.visible;
	}

    storeVirtualValue() {
        (<RadioGroup>this.group).setVirtualValue(this.value);
    }

    resetVirtualValue() {
        (<RadioGroup>this.group).resetVirtualValue();
    }

    /**
     * Return this radio value <input type="radio" value="I mean this value" />
     */
    getValue(): string {
	    return this.value;
    }

}
